export const DASHBOARD_FILTER_LIMITS = Object.freeze({
  askingPrice: { min: 0, max: 1000000, step: 5000 },
  squareFootage: { min: 0, max: 10000, step: 50 },
  pricePerSqFt: { min: 0, max: 500, step: 1 },
  potentialBedrooms: { min: 0, max: 10, step: 1 },
});

export const EMPTY_DASHBOARD_FILTERS = Object.freeze({
  minAskingPrice: 0, maxAskingPrice: 75000,
  minSquareFootage: 0, maxSquareFootage: 10000,
  minPricePerSqFt: 0, maxPricePerSqFt: 500,
  minPotentialBedrooms: 0, listingType: '',
});

const finiteOr = (value, fallback) => value == null || value === '' || !Number.isFinite(Number(value)) ? fallback : Number(value);

export const normalizeDashboardFilters = (filters = {}) => ({
  minAskingPrice: finiteOr(filters.minAskingPrice, 0), maxAskingPrice: finiteOr(filters.maxAskingPrice, 75000),
  minSquareFootage: finiteOr(filters.minSquareFootage, 0), maxSquareFootage: finiteOr(filters.maxSquareFootage, 10000),
  minPricePerSqFt: finiteOr(filters.minPricePerSqFt, 0), maxPricePerSqFt: finiteOr(filters.maxPricePerSqFt, 500),
  minPotentialBedrooms: finiteOr(filters.minPotentialBedrooms, 0), listingType: String(filters.listingType || ''),
});

export const dashboardFilterCount = (filters) => {
  const value = normalizeDashboardFilters(filters);
  return [value.minAskingPrice > 0 || value.maxAskingPrice < 1000000, value.minSquareFootage > 0 || value.maxSquareFootage < 10000,
    value.minPricePerSqFt > 0 || value.maxPricePerSqFt < 500, value.minPotentialBedrooms > 0, Boolean(value.listingType)].filter(Boolean).length;
};

export const filterDashboardRows = (rows, filters, selectors = {}) => {
  const value = normalizeDashboardFilters(filters);
  const askingActive = value.minAskingPrice > 0 || value.maxAskingPrice < 1000000;
  const squareFootageActive = value.minSquareFootage > 0 || value.maxSquareFootage < 10000;
  const pricePerSqFtActive = value.minPricePerSqFt > 0 || value.maxPricePerSqFt < 500;
  const potentialActive = value.minPotentialBedrooms > 0;
  const listingType = value.listingType.trim().toLowerCase();
  return rows.filter((row) => {
    const askingPrice = finiteOr((selectors.getAskingPrice || ((item) => item.asking_price))(row), null);
    const squareFootage = finiteOr((selectors.getSquareFootage || ((item) => item.square_footage))(row), null);
    const pricePerSqFt = finiteOr((selectors.getPricePerSqFt || ((item) => item.price_per_square_foot))(row), null);
    const potentialBedrooms = finiteOr((selectors.getPotentialBedrooms || ((item) => item.potential_extra_bedrooms))(row), null);
    if (askingActive && (askingPrice == null || askingPrice < value.minAskingPrice || askingPrice > value.maxAskingPrice)) return false;
    if (squareFootageActive && (squareFootage == null || squareFootage < value.minSquareFootage || squareFootage > value.maxSquareFootage)) return false;
    if (pricePerSqFtActive && (pricePerSqFt == null || pricePerSqFt < value.minPricePerSqFt || pricePerSqFt > value.maxPricePerSqFt)) return false;
    if (potentialActive && (potentialBedrooms == null || potentialBedrooms < value.minPotentialBedrooms)) return false;
    return !listingType || String(row.listing_type || '').trim().toLowerCase() === listingType;
  });
};

export const listingTypeOptions = (rows) => Array.from(new Set(rows.map((row) => String(row.listing_type || '').trim()).filter(Boolean)))
  .sort((first, second) => first.localeCompare(second));
